import { Form, Select, Checkbox } from "antd";
import { isArray } from "lodash";
import React from "react";
import "./styles.css";
import classes from "../../../components/ReportList/styles.module.css";

export const ULPConfigFilter = (allindexes, config) => {
  if (Array.isArray(config.mandatory_indexes)) {
    config.mandatory_indexes = [
      ...config.mandatory_indexes.filter((el) => allindexes.includes(el)),
    ];
  }
  if (Array.isArray(config.searchable_indexes)) {
    config.searchable_indexes = [
      ...config.searchable_indexes.filter((el) => allindexes.includes(el)),
    ];
  }
};

export const getULPDefaultConfigs = {
  view: "Horizontal View",
  searchable_indexes: [],
  mandatory_indexes: [],
  required_indexes: [],
  report_submission_list: false,
  file_types: [],
  add_to_report_list: false,
};

export const validateULP = (data, validate) => {
  validate.ulp_mandatory_indexes =
    !Array.isArray(data.mandatory_indexes) ||
    data.mandatory_indexes.length === 0; //mandatory indexes
  // validate.ulp_searchable_indexes = (!Array.isArray(data.searchable_indexes) || data.searchable_indexes.length===0);//mandatory indexes
};

const selectElmStyles = { maxWidth: 450 };

function ULP(props) {
  return (
    <div className="app_config_checkbox_class2">
      <Form.Item {...props.formItemLayout} label="Default View">
        <Select
          style={selectElmStyles}
          placeholder="Default View"
          value={props.config.view}
          showSearch={true}
          filterOption={(input, option) => {
            return (
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          }}
          onChange={(e) => props.updateValue(e, props.app_id, "view")}
        >
          <Select.Option value="Horizontal View">Horizontal View</Select.Option>
          <Select.Option value="Vertical View">Vertical View</Select.Option>
        </Select>
      </Form.Item>
      <Form.Item {...props.formItemLayout} label="Searchable Indexes">
        <Select
          style={selectElmStyles}
          mode="multiple"
          showSearch={true}
          filterOption={(input, option) => {
            return (
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          }}
          className={props.validate.ulp_searchable_indexes ? classes.error : ""}
          placeholder="Searchable Indexes"
          value={props.config.searchable_indexes}
          onChange={(e) =>
            props.updateValue(e, props.app_id, "searchable_indexes")
          }
        >
          {props.indexes.map((el) => (
            <Select.Option value={el._id} key={el._id}>
              {el.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item {...props.formItemLayout} label="Mandatory Indexes for Upload">
        <Select
          style={selectElmStyles}
          mode="multiple"
          showSearch={true}
          filterOption={(input, option) => {
            return (
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          }}
          className={props.validate.ulp_mandatory_indexes ? classes.error : ""}
          placeholder="Mandatory Indexes for Upload"
          value={props.config.mandatory_indexes}
          onChange={(e) =>
            props.updateValue(e, props.app_id, "mandatory_indexes")
          }
        >
          {props.indexes.map((el) => (
            <Select.Option value={el._id} key={el._id}>
              {el.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item {...props.formItemLayout} label="Required Indexes">
        <Select
          style={selectElmStyles}
          mode="multiple"
          showSearch={true}
          filterOption={(input, option) => {
            return (
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          }}
          placeholder="Required Indexes"
          value={props.config.required_indexes}
          onChange={(e) =>
            props.updateValue(e, props.app_id, "required_indexes")
          }
        >
          {props.indexes
            .filter((rl) => {
              if (
                Array.isArray(props.config.mandatory_indexes) &&
                props.config.mandatory_indexes.includes(rl._id)
              ) {
                return true;
              }
              if (
                Array.isArray(props.config.searchable_indexes) &&
                props.config.searchable_indexes.includes(rl._id)
              ) {
                return true;
              }
            })
            .map((el) => (
              <Select.Option value={el._id} key={el._id}>
                {el.name}
              </Select.Option>
            ))}
        </Select>
      </Form.Item>
      <Form.Item {...props.formItemLayout} label="Report Submission List">
        <Checkbox
          checked={props.config.report_submission_list}
          onChange={(e) =>
            props.updateValue(
              e.target.checked,
              props.app_id,
              "report_submission_list"
            )
          }
        />
      </Form.Item>
      <Form.Item {...props.formItemLayout} label="File Types">
        <Select
          style={selectElmStyles}
          mode="multiple"
          showSearch={true}
          filterOption={(input, option) => {
            return (
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          }}
          placeholder="File Types"
          value={props.config.file_types}
          onChange={(e) => props.updateValue(e, props.app_id, "file_types")}
        >
          <Select.Option value="Scanned Reports">Scanned Reports</Select.Option>
          <Select.Option value="System Reports">System Reports</Select.Option>
        </Select>
      </Form.Item>
      <Form.Item {...props.formItemLayout} label="Add to Report List">
        <Checkbox
          checked={props.config.add_to_report_list}
          onChange={(e) =>
            props.updateValue(
              e.target.checked,
              props.app_id,
              "add_to_report_list"
            )
          }
        />
      </Form.Item>
    </div>
  );
}

export default React.memo(ULP);
